<template>
    <div>
        <div class="responsive-table">
            <table class="table table-striped table-hover schedule-table">
                <thead>
                <tr>
                    <th scope="col" class="text-center">Станции</th>
                    <th scope="col">№</th>
                    <th scope="col">{{i18n('Bus terminal')}}</th>
                    <th scope="col">{{i18n('Arrival')}}</th>
                    <th scope="col">{{i18n('Parking')}}</th>
                    <th scope="col">{{i18n('Send')}}</th>
                    <th scope="col">{{i18n('Platform')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(station, i) in allStations">
                    <td @click="emitUnset(station, i)">
                        <div class="custom-control custom-checkbox text-center" v-if="i !== 0 && i !== allStations.length - 1">
                            <input type="checkbox"
                                   :checked="isChecked(station)"
                                   :id="'station' + i"
                                   class="custom-control-input"
                                   title=""
                            >
                            <label class="custom-control-label"></label>
                        </div>
                    </td>
                    <td>
                        <span class="float-right">{{i + 1}}</span>
                    </td>
                    <td>{{station.station ? station.station.name : null}}</td>
                    <td>
                        <div style="position: relative">
                            <date-picker class="form-control small_input"
                                         :class="arrival_class[i]"
                                         v-if="i !== 0 && isChecked(station)"
                                         v-model="arrival_times[i]"
                                         :config="options"
                                         @dp-hide="handleArrivalTimeChanged(i)"
                                         @dp-show="dpshow"
                            ></date-picker>
                        </div>
                    </td>
                    <td>
                        <input type="text" class="form-control small_input" disabled
                               v-if="i !== 0 && i !== allStations.length - 1 && isChecked(station)"
                               v-model="wait_times[i]">
                    </td>
                    <td>
                        <div style="position: relative">
                            <date-picker class="form-control small_input"
                                         :class="departure_class[i]"
                                         v-if="i !== allStations.length - 1 && isChecked(station)"
                                         v-model="departure_times[i]"
                                         :config="options"
                                         @dp-hide="handleDepartureTimeChanged(i)"
                                         @dp-show="dpshow"
                            ></date-picker>
                        </div>
                    </td>
                    <td>
                        <input type="text" class="form-control small_input"
                               v-if="i !== allStations.length - 1 && isChecked(station)"
                               @keyup="calculateTimes"
                               v-model="platform[i]"
                        >
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="text-danger text-right">
                {{form.errors.errorMessage}}
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6">
                <div class="form-group form-row">
                    <label class="col-sm-2 col-form-label fs-12 pt-12">{{i18n('Comment')}}:</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control base_input" v-model="form.comment"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SetTimes",
        props: {
            form: {
                type: Object,
                required: true
            },
            stations: {
                type: Array,
                default: []
            },
            allStations: {
                type: Array,
                default: []
            },
            isUpdate: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                options: {
                    format: 'Y-MM-DD H:mm',
                    useCurrent: false,
                    showClear: false,
                    showClose: false,
                    inline: false,
                    // viewMode: 'time',
                    icons: {
                        time: 'mdi mdi-timer',
                        date: 'mdi mdi-timetable',
                        up: 'mdi mdi-chevron-up',
                        down: 'mdi mdi-chevron-down',
                        previous: 'mdi mdi-chevron-left',
                        next: 'mdi mdi-chevron-right',
                        today: 'mdi mdi-calendar-today',
                        clear: 'mdi mdi-delete',
                        close: 'mdi mdi-close-box'
                    }
                },
                arrival_times: [],
                departure_times: [],
                wait_times: [],
                platform: [],
                arrival_class: [],
                departure_class: [],
            }
        },
        created() {
            // console.log(this.$dp);
        },
        methods: {
            dpshow() {
                let elem = $(document).find('a[data-action="togglePicker"]');
                if (elem.length > 0) {
                    elem[0].click()
                }
            },
            handleArrivalTimeChanged(i) {
                if (new Date(this.arrival_times[i]) < new Date(this.departure_times[i - 1])) {
                    this.arrival_class[i] = 'text-danger';
                    this.$forceUpdate();
                    return;
                }
                this.arrival_class[i] = '';
                this.$forceUpdate();

                this.calculateTimes();
            },
            handleDepartureTimeChanged(i) {
                // if arrival_time is `0` then there is no need to check with its departure time
                if ((new Date(this.departure_times[i]) < new Date(this.arrival_times[i]))
                        && i !== 0
                ) {
                    this.departure_class[i] = 'text-danger';
                    this.$forceUpdate();
                    return;
                }
                this.departure_class[i] = '';
                this.$forceUpdate();

                this.calculateTimes();
            },
            calculateTimes() {
                let details = [];
                let last_d = 0;
                let sum = 0;
                let i = 0;
                this.emitData();
                if (this.form.id > 0) {
                    this.arrival_times[0] = this.departure_times[0];
                    this.departure_times[this.departure_times.length - 1] = this.arrival_times[this.arrival_times.length - 1];
                }
                this.allStations.forEach((item, key) => {
                    let a_date = new Date(this.arrival_times[key] || this.departure_times[key]);
                    let d_date = new Date(this.departure_times[key] || this.arrival_times[key]);

                    let a_time = this.$moment(a_date).unix();
                    let d_time = this.$moment(d_date).unix();

                    if (a_time > 0 && d_time > 0) {
                        details.push({
                            routes_station_id: item.id,
                            platform: this.platform[key],
                            estimated_time_of_arrival: null,
                            estimated_time_of_departure: null,
                        });
                        if (i === 0) {
                            last_d = a_time;
                        }
                        this.wait_times[key] = ((d_time - a_time) / 60) || '';
                        let arrival_time = a_time - last_d;
                        let departure_time = d_time - a_time;
                        sum += arrival_time;
                        details[i].estimated_time_of_arrival = sum;
                        sum += departure_time;
                        details[i].estimated_time_of_departure = sum;
                        details[i].platform = this.platform[key];
                        last_d = d_time;
                        i++;
                    }
                });
                if (details.length) {
                    this.form.schedule_trip_details = details;
                }
            },
            recalculateTimes() {
                let time = this.$moment(this.form.begin_at).format('H:mm');
                let day = this.$moment().format('Y-MM-DD');
                let start = this.$moment(day + ' ' + time).unix() * 1000;
                this.allStations.forEach((station, key) => {
                    let item = this.form.schedule_trip_details.find(el => station.id === el.routes_station_id);
                    if (item) {
                        this.arrival_times[key] = this.$moment(start + item.estimated_time_of_arrival * 1000).format('Y-MM-DD H:mm');
                        this.departure_times[key] = this.$moment(start + item.estimated_time_of_departure * 1000).format('Y-MM-DD H:mm');
                        this.wait_times[key] = (item.estimated_time_of_departure - item.estimated_time_of_arrival) / 60;
                        this.platform[key] = item.platform;
                    }
                });
            },
            emitData() {
                this.$emit('timesChanged', this.arrival_times, this.departure_times);
            },
            emitUnset(item, i) {
                this.arrival_times[i] = null;
                this.departure_times[i] = null;
                this.$emit('unsetStation', item);
            },
            isChecked(item) {
                return !!this.stations.find(it => it.id === item.id);
            }
        },
        watch: {
            stations: function () {
                this.calculateTimes();
            },
            isUpdate: function (val) {
                if (val === true) {
                    this.recalculateTimes();
                }
            }
        }
    }
</script>

<style scoped>

</style>
